// extracted by mini-css-extract-plugin
export default {"introduce":"Introduce_introduce__fO2FP","wrapper":"Introduce_wrapper__Hc0EP","heading":"Introduce_heading__gJEDf","desc":"Introduce_desc__FK6Qi"};